import {
  type QueryKey,
  useQuery,
  type UseQueryOptions,
} from '@tanstack/react-query';

import type { GoogleGeocoderResult } from '@cobliteam/common-types/src/google';

import { GeocodeRequester, type LatLng } from '@cobliteam/api-lib';

import { Environment } from '@cobliteam/react-environments';

const env = Environment.getInstance().getEnvironment();
export const geocodeRequester = new GeocodeRequester({
  host: env.herbieApiHost,
});

export const QUERY_KEY: QueryKey = ['GEOCODE'];

const useGeocode = () => {
  const getAddress = async (latLng: LatLng) => {
    const address = await geocodeRequester.getAddress(latLng);
    return address;
  };

  const useGetAddress = (latLng: LatLng, options?: UseQueryOptions<string>) => {
    return useQuery<string>({
      queryKey: [latLng.lat, latLng.lng],
      queryFn: () => getAddress(latLng),
      ...options,
    });
  };

  const useGoogleGeocoder = (
    latLng: LatLng,
    options?: UseQueryOptions<GoogleGeocoderResult>
  ) => {
    const geocoder = new google.maps.Geocoder();
    const location = new google.maps.LatLng(latLng.lat, latLng.lng);

    return useQuery<GoogleGeocoderResult>({
      queryKey: [QUERY_KEY, latLng.lat, latLng.lng],
      queryFn: () =>
        geocoder.geocode({ location }).then((response) => response.results[0]),
      ...options,
    });
  };

  return {
    getAddress,
    useGetAddress,
    useGoogleGeocoder,
  };
};

export default useGeocode;
